/**
* Circle CTA JS
* -----------------------------------------------------------------------------
*
* All the JS for the Circle CTA component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'circle-cta',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.circle-cta__circle-link' ).on( 'mouseenter', function() {
        const component = $( this ).closest( '.circle-cta' );
        $( component ).addClass( 'is-animated' );
      } ).on( 'mouseleave', function() {
        const component = $( this ).closest( '.circle-cta' );
        $( component ).removeClass( 'is-animated' );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'circle-cta', COMPONENT );
} )( app );
